import axios from "axios";
import { TableChart, ViewList } from "@material-ui/icons";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useStyles } from "modules/classes/style";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import React, { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import {
  auditColumnDefs,
  columnDefs as gridcolDef,
  fields,
  status as questionStatuses,
  searchColumnDefs as searchGridColumnDefs
} from "../constants/QuestionBankConstants";
import { setQuestionIds } from "../dashboard/Dashboard-Service";
import {
  apiPaths,
  deleteData,
  get,
  postData,
} from "../platform-components/api-integration-util";
import ChartCard from "../platform-components/ChartCard";
import Grid from "../platform-components/grid/Grid";
import { PreLoader } from "../platform-components/PreLoader";
import SearchQB from "../platform-components/search-qb/searchQB";
import { Toaster } from "../platform-components/Toaster";
import { setItemToStorage } from "../platform-components/utils/common-utils";
import { setEditQuestion, checkPermission } from "../platform-components/utils/configuration";
import { hasPermission, getStoredPermissions } from "../platform-components/utils/permission.service";
import { filterBySubjectScope, isSubjectScoped, hasAllSubjectsBypass } from "../platform-components/utils/subject-scope";
import {
  getRoleNameList,
  getUserDetails,
  setclickedParamsForAudit,
} from "../platform-components/utils/shared-data.service";
import videoImage from "images/videoCard.jpg";
import inProgress from "images/progress.jpg";
import done from "images/done.jpg";
import noData from "images/no-data.jpg";
import { AppContext } from "context/AppContext";
import { DialogTitle, Grid as Gd } from "@material-ui/core";
import TabUnselectedIcon from "@mui/icons-material/TabUnselected";
import QuestionViewModal from "./questionViewmodal";
import NoSubImg from "images/nosubimg.png";
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import { AgGridReact } from "ag-grid-react";
import QuestionCellViewModal from "modules/constants/QuestionCellViewModal";
import noImage from "images/nosubimg.png";


export default function QuestionBank(props) {
  const [includeQB, setIncludeQB] = useState(true);
  const { subjects, userSubjectMap } = useContext(AppContext);
  const [filteredSubject, setFilteredSubject] = useState([]);
  let [chartsData, setChartsData] = useState({});
  let [displayCharts, setDisplayCharts] = useState(false);
  const [currentView, setCurrentView] = useState("tab");
  const [currentViewShowing, setCurrentViewShowing] = useState("subject");
  const [currentViewSelectedSubject, setCurrentViewSelectedSubject] =
    useState(null);
  const [currentViewSelectedTopicsList, setCurrentViewSelectedTopicsList] =
    useState(null);
  const [selectedTopicsList, setSelectedTopicsList] = useState([]);
  const [openVQ, setOpenVQ] = useState(false);
  const classes = useStyles();
  const [QBCount, setQBCount] = useState(0);
  const [nxtQuestion, setNxtQuestion] = useState(0);
  const [prevQuestion, setPrevQuestion] = useState(0);
  let [questionData, setQuestionData] = useState({});
  const [open, setOpen] = useState(false);
  const [questionListopen, setQuestionListopen] = useState(false);
  const [deletedQnId, setDeletedQnId] = useState()
  const [questionId, setQuestionId] = useState("");
  const [searchRowData, setSearchRowData] = useState([])
  const [openModal, setOpenModal] = useState(false);
  const [selectedQuestionToShow, setSelectedQuestionToShow] = useState("");

  // Subject download state
  const [showSubjectDownloadModal, setShowSubjectDownloadModal] = useState(false);
  const [downloadSubjectId, setDownloadSubjectId] = useState(null);
  const [downloadSubjectName, setDownloadSubjectName] = useState('');
  const [dlIncludeQuestion, setDlIncludeQuestion] = useState(true);
  const [dlIncludeAnswer, setDlIncludeAnswer] = useState(false);
  const [dlIncludeExplanation, setDlIncludeExplanation] = useState(false);
  const [dlSelectedStatuses, setDlSelectedStatuses] = useState(['APPROVED']);

  const allQuestionStatuses = [
    { key: 'APPROVED', label: 'Approved' },
    { key: 'SAVED', label: 'Saved' },
    { key: 'SENT FOR APPROVAL', label: 'Sent For Approval' },
    { key: 'NEED CORRECTION', label: 'Need Correction' },
    { key: 'REJECTED', label: 'Rejected' },
  ];

  const handleStatusToggle = (statusKey) => {
    setDlSelectedStatuses((prev) =>
      prev.includes(statusKey)
        ? prev.filter((s) => s !== statusKey)
        : [...prev, statusKey]
    );
  };

  const handleSubjectDownloadClick = (e, subject) => {
    e.stopPropagation();
    setDownloadSubjectId(subject.subjectId);
    setDownloadSubjectName(subject.subject);
    setDlIncludeQuestion(true);
    setDlIncludeAnswer(false);
    setDlIncludeExplanation(false);
    setDlSelectedStatuses(['APPROVED']);
    setShowSubjectDownloadModal(true);
  };

  const handleSubjectDownload = () => {
    const requestBody = {
      subjectId: downloadSubjectId,
      includeExplanation: dlIncludeExplanation,
      includeQuestion: dlIncludeQuestion,
      includeAnswer: dlIncludeAnswer,
      statuses: dlSelectedStatuses,
    };
    axios.post(
      process.env.REACT_APP_BASE2_PATH + apiPaths.downloadBySubject,
      requestBody,
      {
        headers: { tenantId: getUserDetails().tenantId, userEmail: getUserDetails().email },
        responseType: 'blob',
      }
    )
      .then((res) => {
        const blob = new Blob([res.data], { type: res.headers['content-type'] });
        let fileName = "Questions_" + downloadSubjectName + ".docx";
        const disposition = res.headers['content-disposition'];
        if (disposition && disposition.includes("filename=")) {
          const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (match != null && match[1]) {
            fileName = match[1].replace(/['"]/g, '');
          }
        }
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        setShowSubjectDownloadModal(false);
      })
      .catch((err) => {
        console.error("Download failed:", err);
        setShowSubjectDownloadModal(false);
      });
  };

  const [columnDefs] = useState([
    {
      headerName: "Question Id", field: "questionId",
      width: 130,
      filter: true,
      cellRendererFramework: (params) => (
        <div
          className="text-link"
          onClick={() => handleQId(params.value)}
          style={{ cursor: "pointer" }}
        >
          {params.value}
        </div>
      ),
    },
    {
      headerName: "Question",
      field: "questionPlainText",
      width: 200,
      filter: true,
      tooltipField: "questionPlainText",
      cellRendererFramework: (params) => <QuestionCellViewModal value={params.value} />
    },
    { headerName: "Subject", field: "subject", filter: true },
    { headerName: "Subject Id", field: "subjectId" },
    { headerName: "Question Status", field: "questionStatus" },
    { headerName: "Question Complexity", field: "questionComplexity" },
  ]);



  const handleClickOpen = (data) => {
    setDeletedQnId(data.questionId)
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleQuestionListClose = () => {
    setQuestionListopen(false);
  };
  const handleDeleteQuestion = async () => {

    const response = await deleteData(apiPaths.deleteQuestion, {
      data: [deletedQnId],
      headers: {
        tenantId: getUserDetails().tenantId,
        userEmail: getUserDetails().email,
      },

    })

    handleClose()
    if (response.result == "Success") {
      Toaster(toast.TYPE.SUCCESS, "Question deleted Successfully");
      refreshSubjectQuestions();
    } else {

      Toaster(toast.TYPE.SUCCESS, "Error in deleting question");
    }


  }
  const handleCardView = () => {
    setCurrentView("tab");
    setCurrentViewShowing("subject");
  };
  const handleTableView = () => {
    resetTable()
    setCurrentView("table");
    setCurrentViewShowing("subject");
  };



  useEffect(() => {
    getDashboardGraphData();
  }, []);


  useEffect(() => {
    if (!subjects || !subjects.length) {
      setFilteredSubject([]);
      return;
    }
    // Unified scoping: empty userSubjects = unrestricted, "Data Scope / All Subjects" = bypass.
    // See subject-scope.ts.
    if (!isSubjectScoped() || hasAllSubjectsBypass()) {
      setFilteredSubject(subjects);
    } else {
      setFilteredSubject(
        filterBySubjectScope(subjects, (s) => s.subjectId)
      );
    }
  }, [userSubjectMap, subjects])


  const getDashboardGraphData = () => {
    // let requestparam = {admin: false};
    let requestparam = {};
    let role = getRoleNameList();
    // if (role === 'Admin') {
    //   requestparam.admin = true;
    // }
    setDisplayCharts(false);
    postData(apiPaths.qbStats, { data: [], params: requestparam }).then(
      (data) => {
        if (data.result && data.result.viewBySubject) {
          prepareChrtObj(data.result.viewBySubject, "Subject");
        }
        if (data.result && data.result.viewByComplexity) {
          prepareChrtObj(data.result.viewByComplexity, "Complexity");
        }
        if (data.result && data.result.viewByCreatedBy) {
          prepareChrtObj(data.result.viewByCreatedBy, "Created By");
        }

        if (data.result && data.result.viewByTags) {
          prepareChrtObj(data.result.viewByTags, "Tag");
        }
        if (data.result && data.result.viewByTopic) {
          prepareChrtObj(data.result.viewByTopic, "Topic");
        }

        setTimeout(() => {
          let len = Object.getOwnPropertyNames(chartsData).length;
          let expectedLen = checkPermission('Question Bank', 'View All Questions') || role.includes("Admin") ? 1 : 3;
          if (len >= expectedLen) {
          }
        });
      }
    );
  };

  const prepareChrtObj = (res, name) => {
    const chartData = res.map(item => ({
      name: item.name || 'No Value',
      count: item.count || 0,
    }));
    setChartsData((prev) => ({ ...prev, [name]: chartData }));
  };

  let comments;
  let [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [gridOptions, setGridOptions] = useState({});
  const [gridApi, setGridApi] = useState();
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [selectedQuestionEditable, setSelectedQuestionEditable] = useState(false);

  let [displayAudit, setDisplayAudit] = useState(false);
  let auditGridApi = useRef();
  let [auditGridOptions, setAuditGridOptions] = useState({});
  const link = (params) => {
    return (
      <div className="text-link" onClick={() => nav(params?.value)}>
        {params?.value}
      </div>
    );
  };
  const button = (params) => {
    return (
      <div>
        <button data-toggle="modal" data-target="#myModal" type="button" value="Audit" onClick={() => { onAuditClick(params?.data.questionId, params.data.tenantId, params); }} style={{ "margin-right": "10px" }}>
          Audit
        </button>


        {checkPermission('Question Repo', 'Delete') && (
          <IconButton className="delete-icon" style={{ padding: "0px", marginLeft: "10px" }} aria-label="delete" onClick={() => { handleClickOpen(params.data) }}>
            <DeleteIcon />
          </IconButton>
        )}


        {/* <button
          type="button"
          onClick={() => nav(params?.data.questionId, true)}
          value="Edit"
          style={{ "margin-right": "10px" }}
        >
          Edit
        </button> */}
      </div>
    );
  };
  const onAuditClick = (questionId, tenantId, params) => {
    setclickedParamsForAudit(params);
    get(apiPaths.questionstatusaudit, { questionId, tenantId })
      .then((res) => {
        if (res?.result) {

          // Toaster(toast.TYPE.SUCCESS, "Audit Retrieved Successfully");
          auditGridOptions.columnDefs = auditColumnDefs;
          res.result.sort((e1, e2) => e2.auditId - e1.auditId);
          auditGridOptions.rowData = res?.result;
          auditGridOptions.paginationPageSize = 20;
          auditGridOptions.pagination = true;
          auditGridOptions.domLayout = "";
          auditGridOptions.onGridReady = (params) => {
            auditGridApi.current = params.api;
          };
          setTimeout(() => auditGridApi?.current?.setRowData(res?.result));
          setDisplayAudit(true);
        }
      })
      .catch((ele) => {

        Toaster(toast.TYPE.SUCCESS, "Error while retrieving audit data");
      });
  };

  const handleQId = (id) => {
    setEditQuestion(true);
    if (isIntegerString(id)) {
      props.history.push("/app/question/" + id + "?qbpage=true");
    } else {
      get(apiPaths.questionByText, { question: id })
        .then(({ result }) => {
          setQuestionListopen(true);
          setRowData(result);
        });
    }
  };

  const handleSearch = ({
    approvedBy,
    courseIds,
    subjectIds,
    tagIds,
    topicIds,
    createdBy,
    updatedBy,
    questionComplexity,
    numOfTimesUsedInExam,
    issueReported,
    includeQuestionsFromQB,
    createdDate,
    updatedDate,
  }) => {
    const body = {
      courseIds: courseIds.map((el) => el.value),
      subjectIds: subjectIds.map((el) => el.value),
      tagIds: tagIds.map((el) => el.value),
      topicIds: topicIds.map((el) => el.value),
      approvedBy: approvedBy?.label,
      createdBy: createdBy?.label,
      updatedBy: updatedBy?.label,
      numOfTimesUsedInExam: +numOfTimesUsedInExam,
      issueReported: issueReported?.value,
      questionComplexity: questionComplexity.value,
      includeQuestionsFromQB: includeQuestionsFromQB?.value ?? includeQuestionsFromQB ?? includeQB,
    };

    if (createdDate) {
      body["createdDate"] = new Date(createdDate);
    }

    if (updatedDate) {
      body["updatedDate"] = new Date(updatedDate);
    }

    postData(apiPaths.searchQB, {
      data: body,
    }).then((res) => {
      const responseData = filterBySubjectScope(
        res?.result || [],
        (q) => q.subjectId ?? q.subject_id
      );
      setRowData(responseData);
      //setSearchRowData(responseData)
      // setItemToStorage("qbData", responseData);
      setLoading(false);
    });
  };

  const onHandleSubjectClick = (e) => {
    setCurrentViewSelectedSubject(e.subjectId);
    setCurrentViewSelectedTopicsList(e.topics);
    setCurrentViewShowing("topic");
    handleSearch({
      courseIds: [],
      subjectIds: [{ value: e.subjectId }],
      tagIds: [],
      topicIds: selectedTopicsList.map((el) => {
        return {
          value: el,
        };
      }),
      numOfTimesUsedInExam: 0,
      questionComplexity: { value: "ALL" },
      includeQuestionsFromQB: (e.subjectId !== 0)
    });
  };

  const refreshSubjectQuestions = () => {
    handleSearch({
      courseIds: [],
      subjectIds: [{ value: currentViewSelectedSubject }],
      tagIds: [],
      topicIds: selectedTopicsList.map((el) => {
        return {
          value: el,
        };
      }),
      numOfTimesUsedInExam: 0,
      questionComplexity: { value: "ALL" },
      includeQuestionsFromQB: (currentViewSelectedSubject !== 0)
    });
  }

  const onHandleTopicClick = (e) => {
    let topicSelect;
    if (selectedTopicsList.includes(e.topicId)) {
      setSelectedTopicsList(
        selectedTopicsList.filter((el) => el !== e.topicId)
      );
      topicSelect = selectedTopicsList.filter((el) => el !== e.topicId);
    } else {
      setSelectedTopicsList([...selectedTopicsList, e.topicId]);
      topicSelect = [...selectedTopicsList, e.topicId];
    }
    handleSearch({
      courseIds: [],
      subjectIds: [{ value: currentViewSelectedSubject }],
      tagIds: [],
      topicIds: topicSelect.map((el) => {
        return {
          value: el,
        };
      }),
      numOfTimesUsedInExam: 0,
      questionComplexity: { value: "ALL" },
      includeQuestionsFromQB: includeQB,
    });
  };

  useEffect(() => {
    getAllQuestion()
  }, [rowData]);

  const resetTable = () => setRowData([]);

  const getAllQuestion = () => {
    setItemToStorage("qbData", {});
    // postData(apiPaths.questionslist, {
    //   data: [questionStatuses.APPROVED],
    // }).then((res) => {
    //   const responseData = res?.result;
    //   setRowData(responseData);
    //   // setItemToStorage("qbData", responseData);
    //   setLoading(false);
    // });
    let columnDefs = gridcolDef;
    gridcolDef.forEach((ele) => {
      if (ele?.field === fields.QUESTION_ID) {
        ele.cellRendererFramework = link;
        ele.cellStyle = {};
      }
      if (ele?.headerName === fields.ACTIONS) {
        ele.cellRendererFramework = button;
      }
    });

    const gridOptionsObj = {};
    gridOptionsObj.columnDefs = columnDefs.slice(1, columnDefs.length);
    gridOptionsObj.rowData = rowData;
    gridOptionsObj.paginationPageSize = 25;
    gridOptionsObj.pagination = true;
    gridOptionsObj.onGridReady = (params) => {
      setGridApi(params.api);
    };
    setGridOptions(gridOptionsObj);
  }

  useEffect(() => {
    if (gridApi) {
      gridApi.setRowData(rowData);
    }
    sessionStorage.setItem("routeFrom", "qb");
  }, [rowData, gridApi]);

  useEffect(() => {
    if (selectedQuestion) {
      get(apiPaths.questionbyid, { id: selectedQuestion })
        .then(({ result }) => {

          console.log("result: ", result);
          setQuestionData(result);
        })
        .catch((val) => setQuestionData({}));
      const currentIndex = rowData.findIndex(
        (el) => +el.questionId === selectedQuestion
      );
      setQuestionIds(rowData.map((ele) => ele.questionId));
      setQBCount(rowData[rowData.length - 1]?.questionId);
      setPrevQuestion(
        rowData[currentIndex - 1]?.questionId ?? selectedQuestion
      );
      setNxtQuestion(rowData[currentIndex + 1]?.questionId ?? selectedQuestion);
      setOpenVQ(true);
    }
  }, [rowData, selectedQuestion]);

  const nav = (id, isEdit = false) => {
    console.log("id: ", id);
    setEditQuestion(false);
    setSelectedQuestionEditable(isEdit)
    setSelectedQuestion(id);
    // props.history.push("/app/question/" + id);
  };


  const isIntegerString = (str) => {
    return /^\d+$/.test(str);
  }


  return loading ? (
    <PreLoader />
  ) : (
    <>
      <div className="main-heading">Question Repo</div>
      <Box className={classes.tabWrapper}>
        <IconButton
          aria-label="delete"
          size="medium"
          color={currentView === "tab" ? "secondary" : "default"}
          onClick={handleCardView}
        >
          <ViewList />
        </IconButton>
        <IconButton
          aria-label="delete"
          size="medium"
          color={currentView === "table" ? "secondary" : "default"}
          onClick={handleTableView}
        >
          <TableChart />
        </IconButton>
      </Box>
      <div class="">
        <div
          class=""
          style={{ display: "flex", fontSize: "15px", margin: "10px 0" }}
        >
          <TextField
            id="outlined-basic"
            label="Search"
            placeholder="Search Question by ID / Text"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            size="small"
            value={questionId}
            style={{ width: "100%" }}
            onChange={(item) => {
              setQuestionId(item.target.value);
            }}
          />
          <Button
            disabled={!questionId}
            size="small"
            style={{ marginLeft: "5px" }}
            variant="outlined"
            onClick={() => handleQId(questionId)}
          >
            Search
          </Button>
        </div>
      </div>

      {currentView === "table" ? (
        <>
          <div
            style={{ height: "100%", display: "flex", flexDirection: "column" }}
          >
            {displayCharts && (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                gap: 16,
                marginBottom: 16,
              }}>
                {chartsData["Subject"] && (
                  <ChartCard title="Subject" data={chartsData["Subject"]} height={280} />
                )}
                {chartsData["Complexity"] && (
                  <ChartCard title="Complexity" data={chartsData["Complexity"]} chartType="donut" height={280} />
                )}
                {chartsData["Tag"] && (
                  <ChartCard title="Tag" data={chartsData["Tag"]} height={280} />
                )}
                {chartsData["Topic"] && (
                  <ChartCard title="Topic" data={chartsData["Topic"]} height={280} />
                )}
                {chartsData["Created By"] && (
                  <ChartCard title="Created By" data={chartsData["Created By"]} height={280} />
                )}
              </div>
            )}
            <SearchQB
              displayCharts={displayCharts}
              setDisplayCharts={setDisplayCharts}
              search={handleSearch}
              searchQId={handleQId}
            />

            <Grid gridOptions={gridOptions} parent="questionbank" />
          </div>
          <div
            id="myModal"
            class="modal fade show"
            role="dialog"
            style={{ display: displayAudit ? "block" : "" }}
          >
            <div class="modal-dialog modal-dialog-custom">
              <div class="modal-content">
                <div class="modal-header modal-header-custom">
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    onClick={() => {
                      setDisplayAudit(false);
                    }}
                  >
                    <div class="close-btn">
                      <i class="fa fa-close" aria-hidden="true"></i>
                    </div>
                  </button>
                </div>
                <div class="modal-body modal-body-custom">
                  {displayAudit ? (
                    <div style={{ height: "100%" }}>
                      <Grid
                        gridOptions={auditGridOptions}
                        parent="questionbank"
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>{" "}
        </>
      ) : (
        <>
          {subjects?.length === 0 && false && (
            <Card className={classes.noDataCard}>
              <Box display="flex" justifyContent="center">
                <img src={noData} alt="noData" width="550px"></img>
              </Box>
            </Card>
          )}

          <p style={{ display: "flex", justifyContent: "space-between" }}>

            <Button
              variant="outlined"
              style={{
                margin: "10px",
              }}
              disabled={currentViewShowing === "subject"}
              onClick={() => {
                if (currentViewShowing === "topic") {
                  setSelectedTopicsList([]);
                  setCurrentViewShowing("subject");
                }
              }}
            >
              Back
            </Button>
          </p>
          <Gd className="subjects" container spacing={2}>
            {
              /*
             currentViewShowing === "subject" && (<Gd
                  item
                  xs={2}
                  style={{ cursor: "pointer" }}
                  onClick={() => onHandleSubjectClick({subjectId:0,topics:[]})}
                >
                  <Card className={classes.card}>
                    <Gd item xs={12}>
                      <img
                        src={NoSubImg}
                        alt="classViewImage"
                        className="no-subject-img"
                      ></img>
                    </Gd>
                    <Gd item xs={12}>
                      <CardContent>
                        <Box style={{ minHeight: "40px", maxHeight: "40px" }}>
                          <Typography variant="span" className={classes.title}>
                            No Subject
                          </Typography>
                          <p></p>
                        </Box>
                      </CardContent>
                    </Gd>
                  </Card>
                </Gd>)
                */
            }
            {currentViewShowing === "subject" &&
              filteredSubject?.map((el, i) => (
                <Gd
                  item
                  xs={2}
                  style={{ cursor: "pointer" }}
                  onClick={() => onHandleSubjectClick(el)}
                >
                  <Card className={classes.card} style={{ position: 'relative' }}>
                    <Gd item xs={12}>
                      {el.thumbnailUrl ?
                        <img src={el.thumbnailUrl} alt="classViewImage" width="100%" ></img> : <img src={noImage} width="100%" ></img>}
                    </Gd>
                    <Gd item xs={12}>
                      <CardContent>
                        <Box style={{ minHeight: "40px", maxHeight: "40px", display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                          <div>
                            <Typography variant="span" className={classes.title}>
                              {el?.subject}
                            </Typography>
                            <p>{el?.yearTaught}</p>
                          </div>
                          <IconButton
                            size="small"
                            title="Download Questions"
                            onClick={(e) => handleSubjectDownloadClick(e, el)}
                            style={{ padding: '4px' }}
                          >
                            <DownloadIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      </CardContent>
                    </Gd>
                  </Card>
                </Gd>
              ))}
            {currentViewShowing === "topic" && (
              <>
                <>
                  {currentViewSelectedTopicsList?.map((el, i) => (
                    <Gd
                      item
                      xs={4}
                      style={{ cursor: "pointer" }}
                      onClick={() => onHandleTopicClick(el)}
                    >
                      <Card className={classes.card}>
                        <Gd item xs={12}>
                          <CardContent>
                            <Box
                              style={{ minHeight: "20px", maxHeight: "20px" }}
                            >
                              <Typography
                                variant="span"
                                className={classes.title}
                              >
                                {!selectedTopicsList.includes(el.topicId) && (
                                  <TabUnselectedIcon />
                                )}{" "}
                                {selectedTopicsList.includes(el.topicId) && (
                                  <CheckBoxIcon />
                                )}{" "}
                                {el?.topic}
                              </Typography>
                            </Box>
                          </CardContent>
                        </Gd>
                      </Card>
                    </Gd>
                  ))}
                </>
                {currentViewShowing === "topic" && <Box display="flex" alignItems="center" marginBottom={2} style={{ justifyContent: 'end', width: '100%', marginRight: '10px' }}>
                  <Checkbox
                    checked={!includeQB}
                    onChange={(e) => {
                      setIncludeQB(!e.target.checked)
                      handleSearch({
                        courseIds: [],
                        subjectIds: [{ value: currentViewSelectedSubject }],
                        tagIds: [],
                        topicIds: selectedTopicsList.map((el) => {
                          return {
                            value: el,
                          };
                        }),
                        numOfTimesUsedInExam: 0,
                        questionComplexity: { value: "ALL" },
                        includeQuestionsFromQB: !e.target.checked,
                      });
                    }}
                  />
                  <Typography variant="body1">Show only test questions</Typography>
                </Box>}
              </>
            )}
            <>
              {currentViewShowing === "topic" && (
                <Grid gridOptions={gridOptions} parent="questionbank" />
              )}
              <div
                class="modal fade show"
                role="dialog"
                style={{ display: displayAudit ? "block" : "" }}
              >
                <div class="modal-dialog modal-dialog-custom">
                  <div class="modal-content">
                    <div class="modal-header modal-header-custom">
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        onClick={() => {
                          setDisplayAudit(false);
                        }}
                      >
                        <div class="close-btn">
                          <i class="fa fa-close" aria-hidden="true"></i>
                        </div>
                      </button>
                    </div>
                    <div class="modal-body modal-body-custom">
                      {displayAudit ? (
                        <div style={{ height: "100%" }}>
                          <Grid
                            gridOptions={auditGridOptions}
                            parent="questionbank"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          </Gd>
        </>
      )}
      {selectedQuestion && (
        <QuestionViewModal
          open={openVQ}
          handleClose={() => {
            setOpenVQ(false);
            setSelectedQuestion(null);
          }}
          selectedQuestionEditable={selectedQuestionEditable}
          isEditEnabled={true}
          prevQuestion={prevQuestion}
          nxtQuestion={nxtQuestion}
          questionData={questionData}
          QBCount={QBCount}
          selectedQuestion={selectedQuestion}
          setId={(e) => {
            setSelectedQuestion(e);
          }}
        />
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Make sure you remove every link to the question—in both the question bank and any tests—before you delete it. Question Id: <strong>{deletedQnId}</strong> ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>Close</Button>
          <Button variant="contained"
            onClick={handleDeleteQuestion} color="error" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={questionListopen}
        onClose={handleQuestionListClose}
        PaperProps={{ sx: { minWidth: '80%', minHeight: '80%' } }}
      >
        <DialogContent className="ag-theme-balham ag-grid-main">
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
          ></AgGridReact>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleQuestionListClose}>Close</Button>
        </DialogActions>
      </Dialog>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2">
            Question
          </Typography>
          <Typography sx={{ mt: 2 }}>
            {selectedQuestionToShow}
          </Typography>
        </Box>
      </Modal>

      {/* Subject Download Modal */}
      <Modal
        open={showSubjectDownloadModal}
        onClose={() => setShowSubjectDownloadModal(false)}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box sx={{ p: 3, width: 440, backgroundColor: '#fff', borderRadius: '4px', boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.15)' }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Download - {downloadSubjectName}
          </Typography>

          <Typography variant="subtitle2" sx={{ mb: 1, color: '#555' }}>
            Include in download:
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', ml: 1, mb: 2 }}>
            <FormControlLabel
              control={<Checkbox checked={dlIncludeQuestion} onChange={(e) => setDlIncludeQuestion(e.target.checked)} />}
              label="Question"
            />
            <FormControlLabel
              control={<Checkbox checked={dlIncludeAnswer} onChange={(e) => setDlIncludeAnswer(e.target.checked)} />}
              label="Answer"
            />
            <FormControlLabel
              control={<Checkbox checked={dlIncludeExplanation} onChange={(e) => setDlIncludeExplanation(e.target.checked)} />}
              label="Explanation"
            />
          </Box>

          <Typography variant="subtitle2" sx={{ mb: 1, color: '#555' }}>
            Question statuses to include:
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', ml: 1, mb: 2 }}>
            {allQuestionStatuses.map((s) => (
              <FormControlLabel
                key={s.key}
                control={
                  <Checkbox
                    checked={dlSelectedStatuses.includes(s.key)}
                    onChange={() => handleStatusToggle(s.key)}
                  />
                }
                label={s.label}
              />
            ))}
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              onClick={handleSubjectDownload}
              disabled={dlSelectedStatuses.length === 0}
            >
              Download
            </Button>
            <Button variant="outlined" sx={{ ml: 2 }} onClick={() => setShowSubjectDownloadModal(false)}>
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}
